import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/moulds',
    name: 'PUT_MODULE',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
